import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class TitleResolver implements Resolve<string> {
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
        const coinCodeInParams: string = route.paramMap.get('coinCode') ?? '';
        return `${coinCodeInParams} | Research | IXFI`;
    }
}
